export const PROVIDER_STATUS = {
    INACTIVE: "INACTIVE",
    ACTIVE: "ACTIVE",
};
